import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IInvitationExtrasProducts } from '@app/models/signup';
import { getIconOfServiceIdUsingServicesConfig } from '@app/shared/helpers/services/get-icon-of-service-id-using-services-config';
import { getServiceConfigurationOrThrow } from '@app/shared/helpers/services/get-service-configuration';
import { getProductTitleFromServiceId } from '@app/shared/helpers/services/get-service-title-translated';
import { Subscription } from 'rxjs';

export interface InvitationB2bAccessListDisplayProductsComponentData {
  products: IInvitationExtrasProducts;
  organisation: string;
}

@Component({
  selector: 'app-invitation-b2b-access-list-display-products',
  templateUrl: './invitation-b2b-access-list-display-products.component.html',
  styleUrls: ['./invitation-b2b-access-list-display-products.component.scss'],
})

export class InvitationB2bAccessListDisplayProductsComponent implements OnInit {

  servicesList: [];

  public isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<InvitationB2bAccessListDisplayProductsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvitationB2bAccessListDisplayProductsComponentData,
  ) {
  }

  ngOnInit(): void {
    this.servicesList = Object.keys(this.data.products).length ?
      Object.keys(this.data.products)
        .map(item => this.data.products[item])
        .filter(item => item?.types?.length > 0)
        .map(item => item?.service_id)
        .reduce(function (acc, curr) {
          return acc[curr] ? ++acc[curr] : acc[curr] = 1, acc;
        }, {})
      : [];
  }

  close(): void {
    this.dialogRef.close();
  }

  returnProductIcon(serviceId: number): string {
    return getIconOfServiceIdUsingServicesConfig(serviceId);
  }

  getServiceName(serviceId: number): string {
    return getProductTitleFromServiceId(serviceId);
  }

  returnProductTypeColor(serviceId: number): string {
    const service = getServiceConfigurationOrThrow(serviceId);
    return service.color;
  }

  get hasProductsAccess(): boolean {
    return Object.keys(this.data.products).length > 0;
  }
}
